import { mapState } from 'vuex'
import filter from 'js/filter'
import { getTicketList, paypalAddOrder } from '@/service/vbef'

const MOBILE_REGEX = /^1[3-9]\d{9}$/
const signUpMixins = {
  data() {
    const _this = this
    return {
      filter,
      ticketList: [],
      concurrentList: {
        'zh': [`分论坛1：基因治疗带来CNS疾病治疗的变革`,
          `分论坛2：基因治疗在多元疾病领域的前沿创新`,
          `分论坛3：基因治疗引领未来眼科和耳科治疗的格局重塑`,
          `分论坛4：免疫细胞治疗在自身免疫疾病中的突破性进展 `,
          `分论坛5：免疫细胞治疗在肿瘤疾病中的突破性进展`,
          `分论坛6：下一代免疫细胞疗法浪潮--In Vivo Car-t `,
          `分论坛7：成体干细胞与外泌体，从0到1 `,
          `分论坛8：星辰大海，扬帆起航，iPSC衍生细胞药物`,
          `分论坛9：小核酸药物在心血管与代谢类疾病领域的广阔前景`,
          `分论坛10：基因编辑从体内到体外的应用探索`,
          `分论坛11：全溶瘤病毒、肿瘤疫苗在肿瘤治疗的新突破 `,
          `分论坛12：如何搭建符合CGT产品市场化特征的商业化生产体系`,
          `分论坛13：各国CGT产品质量控制与检测的最新要求与最新技术`,
          `分论坛14：CGT投融资趋势及BD合作机会`,
          `分论坛15：AI+药物研发最新进展与应用`,
          `分论坛16：CGT药物递送系统新技术与最近应用进展`,
          `分论坛17：全球CGT在肿瘤与罕见病领域的临床应用与突破`,
          `分论坛18：全球CGT在CNS、自免及慢性病领域的临床应用与突破`,
          `项目路演1（基因治疗药品，如基因治疗，核酸药物，基因编辑、溶瘤病毒等）`,
          `项目路演2（细胞治疗药品，如免疫细胞治疗、干细胞治疗等；其他先进治疗药品）`],
        'en': [`Forum 1: Gene Therapy Transforming the Treatment Landscape of CNS Disorders`,
          `Forum 2: Frontline Innovations of Gene Therapy Across Diverse Disease Areas`,
          `Forum 3: Reshaping the Future of Ophthalmology and Otology Through Gene Therapy`,
          `Forum 4: Breakthrough Progress of Immune Cell Therapy in Autoimmune Diseases`,
          `Forum 5: Breakthrough Progress of Immune Cell Therapy in Oncology`,
          `Forum 6: The Next Wave of Immune Cell Therapies – In Vivo CAR-T`,
          `Forum 7: Adult Stem Cells and Exosomes: From Zero to One`,
          `Forum 8: iPSC-Derived Cell Therapies: Charting a New Course`,
          `Forum 9: Expanding Horizons of Nucleic Acid Drugs in Cardiovascular and Metabolic Diseases`,
          `Forum 10: Translating Gene Editing Technologies from In Vitro to In Vivo Applications`,
          `Forum 11: Novel Advances of Oncolytic Viruses and Cancer Vaccines in Oncology`,
          `Forum 12: Building a Commercial Manufacturing System Tailored for CGT Products`,
          `Forum 13: Latest Regulatory Requirements and Quality Control Technologies for CGT Products Worldwide`,
          `Forum 14: CGT Investment Trends and Business Development Opportunities`,
          `Forum 15: Advances and Applications of AI in Drug Discovery`,
          `Forum 16: Emerging Technologies and Applications in CGT Drug Delivery Systems`,
          `Forum 17: Global Clinical Advances and Breakthroughs of CGT in Oncology and Rare Diseases`,
          `Forum 18: Global Clinical Advances and Breakthroughs of CGT in CNS, Autoimmune, and Chronic Diseases`,
          `Project Roadshow 1: Gene Therapy Products (Gene Therapy, Nucleic Acid Drugs, Gene Editing, Oncolytic Viruses, etc.)`,
          `Project Roadshow 2: Cell Therapy Products (Immune Cell Therapy, Stem Cell Therapy, and Other Advanced Therapies)`]
      },
      companyprofileother: false,
      companyProfileList: [
        filter.dealLanguage('大型药企', 'Big Pharma'),
        filter.dealLanguage('CGT 创新药企', 'CGT Innovative Pharmaceutical Company '),
        filter.dealLanguage('投资机构（人民币）', 'Investment Agency (RMB Fund)'),
        filter.dealLanguage('投资机构（美元）', 'Investment Agency (USD Fund)'),
        filter.dealLanguage('临床前CRO企业 ', 'Pre-clinical CRO'),
        filter.dealLanguage('临床CRO企业 ', 'Clinical CRO '),
        filter.dealLanguage('CMO/CDMO企业', 'CMO/CDMO'),
        filter.dealLanguage(
          '供应链产品企业（原材料、试剂耗材、仪器设备等）',
          'Supply-Chain Solutions Provider(APIs、Reagent & Consumable Materials、Instrument & Equipment,etc.)'
        ),
        filter.dealLanguage('第三方检测服务企业', 'Testing Service Provider'),
        filter.dealLanguage('细胞存储企业', 'Cell Storage Services'),
        filter.dealLanguage(
          '国际业务服务企业（金融机构、律所等）',
          'Global Business Services(Financial Institution, Law Firm, etc.)'
        ),
        filter.dealLanguage('科研院所/高校', 'Academic & Research Institution/University'),
        filter.dealLanguage('医院/临床机构', 'Hospital/clinical institution'),
        filter.dealLanguage('监管机构/行业协会', 'Regulators/Industry Association'),
        filter.dealLanguage(
          '产业园区/孵化器/加速器等 ',
          'Industrial Park/Incubator/Accelerator, etc.'
        ),
        filter.dealLanguage('患者组织 ', 'Patient Group'),
        filter.dealLanguage('其他，请填写 ', 'Others, please specify'),
      ],
      need2other: false,
      needList: [
        filter.dealLanguage(
          `项目或产品需要宣传推广，如设展、路演等`,
          `Promote projects/products (e.g., exhibitions, presentations)`
        ),
        filter.dealLanguage(`公司/项目融资需求`, `Secure company/project funding`),
        filter.dealLanguage(
          `公司/管线出海BD&融资需求`,
          `BD & financing for company/pipeline to go global`
        ),
        filter.dealLanguage(
          `寻找优秀企业/项目投资&BD需求`,
          `Seek good enterprise/project investment &BD`
        ),
        filter.dealLanguage(`IIT项目合作需求`, `IIT project cooperation`),
        filter.dealLanguage(`学习全球行业最新趋势`, `Follow the latest industry trends worldwide`),
        filter.dealLanguage(`与全球优秀同仁交流`, `Exchange with excellent colleagues worldwide`),
        filter.dealLanguage(
          `寻找优秀供应链产品（原材料、试剂耗材、仪器设备等）`,
          `Seek good supply-chain products (APIs、reagent and consumable materials、instrument and equipment, etc.)`
        ),
        filter.dealLanguage(
          `寻找优秀服务机构（第三方检测、细胞存储、国际金融、律所等）`,
          `Seek good service agencies (third-party testing、cell storage、international financing、law firm)`
        ),
        filter.dealLanguage(`其他，请填写`, `Others，please specify`),
      ],
      serviceList: [
        filter.dealLanguage(
          `海外监管政策深度解析（FDA/EMA最新指南）`,
          `In-depth Analysis of Overseas Regulatory Policies (FDA/EMA Guidelines)`
        ),
        filter.dealLanguage(
          `国内监管动态与审批路径优化（NMPA/CDE实操解读）`,
          `Domestic Regulatory Updates & Approval Pathway Optimization (NMPA/CDE Practices)`
        ),
        filter.dealLanguage(
          `细胞与基因治疗行业标准制定探讨`,
          `Discussion on Industry Standardization for Cell and Gene Therapy`
        ),
        filter.dealLanguage(
          `临床需求对接与患者招募策略`,
          `Clinical Demand Matching & Patient Recruitment Strategies`
        ),
        filter.dealLanguage(
          `商业化路径与支付创新方案（医保、商保、DTP药房）`,
          `Commercialization Strategies & Payment Innovations (Insurance, DTP Pharmacy)`
        ),
        filter.dealLanguage(
          `海内外融资及BD合作机会（美元基金/跨境药企对接）`,
          `Global Financing & BD Opportunities (USD Funds/Cross-border Pharma Partnerships)`
        ),
        filter.dealLanguage(
          `技术前沿与工艺突破（基因编辑/递送系统/CMC难题）`,
          `Technology Frontiers & Process Breakthroughs (Gene Editing/Delivery Systems/CMC Challenges)`
        ),
        filter.dealLanguage(
          `供应链国产替代与成本优化方案`,
          `Domestic Supply Chain Substitution & Cost Optimization`
        ),
        filter.dealLanguage(
          `国际化合作与市场准入策略（欧美/东南亚布局`,
          `Global cooperation and Market Entry Strategies (EU/US/Southeast Asia)`
        ),
        filter.dealLanguage(
          `人才培训与团队能力建设（研发/生产/合规）`,
          `Talent Development & Team Capacity Building (R&D/Production/Compliance)`
        ),
      ],
      activityTicketList: [{
        name: '1. 大会体系活动门票',
        list: [
          `参会门票：大会两日免费会议参会权益（限时免费）`,
          `VIP门票：大会两日参会门票含商务自助午餐及茶歇（原价1600元 | 早鸟价1200元，含普通收费会议参会权益及闭门会）`,
          `大会欢迎晚宴（9月18日晚，原价1500元 | 早鸟价800元）`,
          `大会高端鸡尾酒会（9月19日晚，原价2000元 | 早鸟价1000元）`,
          `定制活动：7天VIP考察团（原价33000元 | 早鸟价25000元，报名后工作人员会联系您缴费）`,
        ]
      }, {
        name: '2. 大会+其他产品组合门票',
        list: [
          `2026CSGCT大会VIP参会+欢迎晚宴（原价3100元 | 早鸟价1900元）`,
          `2026CSGCT大会VIP参会+鸡尾酒会（原价3600元 | 早鸟价2000元）`,
          `2026CSGCT大会VIP参会+欢迎晚宴+鸡尾酒会（原价5100元 | 早鸟价2600元）`,
        ]
      }
      ],
      activityTicketListEn: [{
        name: '1. Standard Conference Passes',
        list: [
          `General Admission (Free):<br/>
            Complimentary access to all open conference sessions for two days (limited-time free registration).`,
          `VIP Pass (RMB 1,600 | Early Bird RMB 1,200):<br/>
            Includes two-day full conference access, business buffet lunches, and coffee breaks.<br/>
            Grants access to paid sessions and private meetings.`,
          `Welcome Dinner (September 18 evening, RMB 1,500 | Early Bird RMB 800)`,
          `Exclusive Cocktail Reception (September 19 evening, RMB 2,000 | Early Bird RMB 1,000)`,
          `Customized Program – 7-Day VIP Delegation Tour (RMB 33,000 | Early Bird RMB 25,000):<br/>
            A premium 7-day CGT industry　VIP delegation tour. Upon registration, our team will contact you for payment and itinerary arrangements.`,
        ]
      }, {
        name: '2. Combined Ticket Packages',
        list: [
          `VIP Pass + Welcome Dinner
            (Original Price RMB 3,100 | Early Bird RMB 1,900)`,
          `VIP Pass + Cocktail Reception
            (Original Price RMB 3,600 | Early Bird RMB 2,000)`,
          `VIP Pass + Welcome Dinner + Cocktail Reception
            (Original Price RMB 5,100 | Early Bird RMB 2,600)`,
        ]
      }
      ],
      currentAddressDto: [],
      addressDtoList: [],
      addressDtos: [],
      ruleValidate2: {
        name: [
          {
            required: true,
            message: filter.dealLanguage('请填写姓名', 'Please fill in your name'),
            trigger: 'blur',
          },
        ],
        compName: [
          {
            required: true,
            message: filter.dealLanguage('请搜索并选择公司', 'Please search and select a company'),
            trigger: 'change',
          },
        ],
        department: [
          {
            required: true,
            message: filter.dealLanguage('请填写部门', 'Please fill in the department'),
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: filter.dealLanguage('请填写职位', 'Please fill in the position'),
            trigger: 'blur',
          },
        ],
        addressId: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        companyProfile: [
          {
            required: true,
            message: filter.dealLanguage('请选择公司性质', 'Please select'),
            trigger: 'change',
          },
        ],
        companyprofileother: [
          {
            required: true,
            message: filter.dealLanguage('请填写具体性质', 'Please fill in the specific nature'),
            trigger: 'blur',
          },
        ],
        concurrent2: [
          {
            required: true,
            type: 'array',
            message: filter.dealLanguage('请选择会议或活动', 'Please select a meeting or event'),
            trigger: 'change',
          },
        ],
        need2: [
          {
            required: true,
            max: 3,
            min: 3,
            type: 'array',
            message: filter.dealLanguage(
              '请选出最重要的3项需求',
              'Please select the top 3 requirements'
            ),
            trigger: 'change',
          },
        ],
        service2: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        activityTicketName: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        activityTicketNameEn: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        mobileVerifyCode: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写正确的验证码',
              'Please fill in the correct verification code'
            ),
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的邮箱', 'Please enter your E-mail'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: filter.dealLanguage('邮箱格式不正确', 'The E-mail format is incorrect'),
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'),
            trigger: 'blur',
          },
          {
            type: 'number',
            message: filter.dealLanguage(
              '手机号格式不正确',
              'The phone number format is incorrect'
            ),
            trigger: 'blur',
            transform(value) {
              if (_this.currentForm.mobileAreaCode == '86')
                return MOBILE_REGEX.test(value) ? Number(value) : false
            },
          },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      appMobileAreaCodeDtos: (state) => state.appMobileAreaCodeDtos,
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
      user: (state) => state.user,
      isWeixinBrowser: (state) => state.isWeixinBrowser,
      vbef_path: (state) => state.vbef_path,
      index2_path: (state) => state.index2_path,
      language: (state) => state.language,
      isMobile: (state) => state.isMobile,
    }),
  },
  methods: {
    ininUserInfo() {
      const user = this.$store.state.user
      this.currentForm.name = user.name || ''
      this.currentForm.compName = user.compName || ''
      this.entityKeyword = user.compName || ''
      this.currentForm.entityId = user.entityId || 0
      this.currentForm.department = user.department || ''
      this.currentForm.title = user.title || ''
      this.currentForm.companyNatureId = user.companyNatureId || null
      this.currentForm.companyNatureOtherTagName = user.companyNatureOtherTagName || ''
      this.currentForm.mobile = user.mobile || ''
      this.currentForm.mobileAreaCode = user.mobileAreaCode || ''
      this.currentForm.email = user.email.includes('@privaterelay.appleid.com') ? '' : (user.email || '')
    },
    async getTicketList() {
      let res = await getTicketList({
        actId: this.activityId,
        payType: this.language == 'zh' ? 1 : 2,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'ticketList', res.data)
        if (res.data.length) {
          this.currentTicket = res.data[0]
          this.currentForm.activityTicketId = res.data[0].id
        }
      }
    },
    handleChangeNT(value, isfirst = 0) {
      if (!isfirst) this.currentForm.companyNatureOtherTagName = ''
      if (!value || !this.companyNatureTags.length) {
        this.compNTother = ''
        return
      }
      let item = this.companyNatureTags.find((a) => a.id === value)
      if (
        item.name.indexOf('其他') > -1 ||
        item.name.indexOf('Other') > -1 ||
        item.name.indexOf('other') > -1
      ) {
        this.compNTother = item.name
      } else {
        this.compNTother = ''
      }
    },
    handleChangeNeed(arr) {
      this.need2other = false
      for (let item of arr) {
        if (item.indexOf('其他') > -1 || item.indexOf('Other') > -1 || item.indexOf('other') > -1) {
          this.need2other = true
          break
        }
      }
    },
    submitEn() {
      if (this.buttonLoading) return
      if (!this.user_key) {
        this.login(this.ininUserInfo)
        return
      }
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true

          let { activityTicketId, ...params } = this.currentForm

          let ticketParamsStr = JSON.stringify(params)
          let res = await paypalAddOrder({
            activityTicketId: activityTicketId,
            checkFormJson: ticketParamsStr,
            loginPlatform: 8,
            payType: 4,
          })
          this.buttonLoading = false
          if (res.code == 0) {
            window.location.href = res.data.paypalUrl
          } else {
            if (this.isMobile) {
              this.$notify(res.enMsg || res.msg)
            } else {
              this.$Message.error(res.enMsg || res.msg)
            }
          }
        } else {
          if (this.isMobile) {
            this.$notify('Please complete the form and submit it')
          } else {
            this.$Message.error('Please complete the form and submit it')
          }

        }
      })
    },
  },
}
export { signUpMixins }